// src/hooks/useNotifications.js

import { 
  collection, 
  query, 
  orderBy, 
  onSnapshot, 
  getDocs, 
  writeBatch 
} from 'firebase/firestore';
import { useState, useEffect } from 'react';
import { useAuthCliente } from '../context/AuthClienteContext';

export function useNotifications() {
  const { db, currentUser } = useAuthCliente();
  const [notifications, setNotifications] = useState([]);
  // 1. Añadimos estado para el contador
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!currentUser?.companyId || !currentUser?.uid) return;

    const path = `companies/${currentUser.companyId}/end_customers/${currentUser.uid}/notifications`;
    
    const q = query(
      collection(db, path),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(
      q,
      snapshot => {
        const items = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        setNotifications(items);

        // 2. Calculamos y actualizamos el contador cada vez que los datos cambian
        const count = items.filter(n => !n.read).length;
        setUnreadCount(count);
      },
      err => {
        console.error('Error en notificaciones:', err);
        setNotifications([]);
        setUnreadCount(0); // Reseteamos en caso de error
      }
    );

    return () => unsubscribe();
  }, [db, currentUser]);

  const markAllAsRead = async () => {
    if (!currentUser?.companyId || !currentUser?.uid) return;
    const path = `companies/${currentUser.companyId}/end_customers/${currentUser.uid}/notifications`;
    const notifCol = collection(db, path);
    const snap = await getDocs(notifCol);
    const batch = writeBatch(db);
    snap.docs.forEach(docSnap => {
      // Solo actualizamos las que no están leídas para optimizar escrituras
      if (!docSnap.data().read) {
        batch.update(docSnap.ref, { read: true });
      }
    });
    await batch.commit();
  };

  // 3. Devolvemos el contador junto con lo demás
  return { notifications, unreadCount, markAllAsRead };
}